import type { User } from "./types"

const KNOWN_REASONS = [
	"email_not_verified",
	"parental_consent",
	"need_age_verification",
	"blocked",
	"system_blocked",
	"temp_blocked",
] as const

export type KnownBlockedReason = (typeof KNOWN_REASONS)[number]

export type AccessState =
	| { kind: "anonymous" }
	| { kind: "rejected" }
	| { kind: "authenticated" }
	| { kind: "blocked"; reason: KnownBlockedReason }

function isKnownReason(value: string): value is KnownBlockedReason {
	return (KNOWN_REASONS as readonly string[]).includes(value)
}

export function computeAccessState(user: User | null): AccessState {
	if (user === null) return { kind: "anonymous" }
	if (!user.blocked) return { kind: "authenticated" }

	if (user.reason_blocked && isKnownReason(user.reason_blocked)) {
		return { kind: "blocked", reason: user.reason_blocked }
	}
	return { kind: "blocked", reason: "blocked" }
}
